module.exports = __webpack_public_path__ + "static/media/logo-epa-mini-L.4f49a1d7.svg";